import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getsubTopicData = createAsyncThunk("topic/subtopic", async (subjectId) => {
    return await apiInstance.get(`/subject/subtopic?subTopicId=${subjectId}`, {
      headers: authHeader(),
    });
  });
  export const getAllSubTopicData = createAsyncThunk("subtopic/all", async () => {
    return await apiInstance.get(`/sub-topic/all?page=1&limit=10`, {
      headers: authHeader(),
    });
  });

const initialState = {
  subjectDataLoading: false,
  subjectLoading:false
  };
  
  const subjectSlice = createSlice({
    name: "subTopicSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
   
      builder.addCase(getsubTopicData.pending, (state, action) => {
        state.subjectDataLoading = true;
      });
      builder.addCase(getsubTopicData.fulfilled, (state, action) => {
        state.subTopicData = action.payload.data;
        state.subjectDataLoading = false;
      });
      builder.addCase(getsubTopicData.rejected, (state, action) => {
        state.subjectDataLoading = false;
      });
      builder.addCase(getAllSubTopicData.pending, (state, action) => {
        state.subjectLoading = true;
      });
      builder.addCase(getAllSubTopicData.fulfilled, (state, action) => {
        state.subTopicData = action.payload.data;
        state.subjectLoading = false;
      });
      builder.addCase(getAllSubTopicData.rejected, (state, action) => {
        state.subjectLoading = false;
      });
    },
  });
  export default subjectSlice.reducer;
  